import { Component, Input, OnInit, OnDestroy, inject } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { debounceTime, distinctUntilChanged, Subscription } from 'rxjs';
import { UserFormFacade } from '../../../../../Facades/user-form.facade';
import { IntuneUser } from '../../../../../Models/Intune/intune-user.model';
import { COMMON_IMPORTS } from '../../../../Shared/common-imports';

@Component({
  selector: 'app-user-create-step-1',
  imports: [COMMON_IMPORTS],
  templateUrl: './user-create-step-1.component.html',
  styleUrl: './user-create-step-1.component.scss',
})
export class UserCreateStep1Component implements OnInit, OnDestroy {
  @Input({ required: true }) formGroup!: FormGroup;

  readonly facade = inject(UserFormFacade);

  private _searchSub?: Subscription;

  ngOnInit(): void {
    this.initSearchSubscription();
  }

  ngOnDestroy(): void {
    this._searchSub?.unsubscribe();
  }

  private initSearchSubscription(): void {
    this._searchSub = this.formGroup.controls['userSearch'].valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(value => {
      if (typeof value === 'string') {
        this.facade.setSearchTerm(value);
        if (this.facade.selectedUser()) {
          this.facade.setSelectedUser(null);
        }
      }
    });
  }

  displayUser(user: IntuneUser): string {
    return user?.displayName ?? '';
  }

  onUserSelected(event: MatAutocompleteSelectedEvent): void {
    const user = event.option.value as IntuneUser;
    this.facade.setSelectedUser(user);
  }
}
